import './card-with-year-picker.style.sass';
import template from './card-with-year-picker.tpl.pug';

class CardWithYearPickerController {
    selectPreviousYear() {
        return this.onYearChange({
            year: this.year - 1
        });
    }

    selectNextYear() {
        return this.onYearChange({
            year: this.year + 1
        });
    }
}

export default {
    selector: 'dbADashboardCardWithYearPicker',
    template: template(),
    controller: CardWithYearPickerController,
    transclude: true,
    bindings: {
        name: '@',
        year: '<',
        onYearChange: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/card-with-year-picker/card-with-year-picker.cmpt.js